import classNames from 'classnames';
import css from './CountBadge.module.scss';

interface CountBadgeProps {
  count: number;
  className?: string;
}

/**
 * Small circular count badge — white background, dark text. A circle for single
 * digits, a pill for 2+. Shared by the desktop OmniFilter button and the mobile
 * filter triggers to show how many filter terms are active.
 */
export const CountBadge = ({ count, className }: CountBadgeProps) => (
  <span className={classNames(css.badge, className)}>{count}</span>
);
